<template>
  <tr>
    <td>
      {{ item.employees }}
    </td>
    <td>
      {{ item.project.name }}
    </td>
    <td>{{ getWeeks(item['first_week'], item['last_week']) || '-' }}</td>
    <td>
      <div class="d-flex align-center">
        <template v-if="item['report_sign_photo']">
          <v-dialog v-if="fileType === 'image'" v-model="modal" width="1200">
            <template v-slot:activator="{ on, attrs }">
              <v-btn text icon v-bind="attrs" v-on="on">
                <slot name="icon">
                  <IconsFinanceReport />
                </slot>
              </v-btn>
            </template>
            <v-img :src="apiDomain + '/' + item['report_sign_photo']" class="mx-auto" contain>
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="secondary lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <v-btn @click="modal = false" fixed top right fab small dark class="mt-16">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-btn :href="apiDomain + '/' + item['report_sign_photo']" target="_blank" fixed bottom right fab dark class="mb-16" color="#277faf">
              <IconsButton icon="button-save" width="30" height="30" color="white"/>
            </v-btn>
          </v-dialog>
          <PdfModalShow v-else :url="item['report_sign_photo']">
            <IconsFinanceReport slot="icon" />
          </PdfModalShow>
        </template>
        <FinanceInvoiceItemModal :item="report" />
      </div>
    </td>
    <td>
      <div>
        <BaseTooltip :tooltip="status.text">
          <IconsFinanceSalaryStatus class="mt-2"/>
        </BaseTooltip>
      </div>
    </td>
    <td>
      <ButtonShow to-name="financeSalaryListShow" :to-params="item.id" />
    </td>
  </tr>
</template>

<script>
import PdfModalShow from "components/pdf/PdfModalShow";
import IconsFinanceReport from "components/icons/finance/IconsFinanceReport";
import FinanceInvoiceItemModal from "components/finance/invoice/FinanceInvoiceItemModal";
import IconsFinanceSalaryStatus from "components/icons/finance/IconsFinanceSalaryStatus";
import ButtonShow from "components/ButtonShow";
import {mapGetters} from "vuex";
import IconsButton from "components/icons/button/IconsButton";
export default {
  name: "FinanceSalaryListTableItem",
  components: {
    IconsButton,
    ButtonShow, IconsFinanceSalaryStatus, FinanceInvoiceItemModal, IconsFinanceReport, PdfModalShow},
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    ...mapGetters(['apiDomain']),
    report() {
      return {
        title: this.localStorage.translations.pages.finance['invoice-table'].report,
        info: [
          {
            name: this.localStorage.translations.pages.finance['invoice-table'].client,
            value: this.item.client.name
          },
          {
            name: this.localStorage.translations.pages.finance['invoice-table'].project,
            value: this.item.project.name
          },
          {
            name: this.localStorage.translations.pages.finance['invoice-table'].address,
            value: this.item.project.street + ', ' + this.item.project.zip + ', ' + this.item.project.city
          },
          {
            name: this.localStorage.translations.pages.finance['invoice-table'].weeks,
            value: this.item['first_week'] && this.item['last_week'] ? this.getWeeks(this.item['first_week'], this.item['last_week']) : '-'
          },
          {
            name: this.localStorage.translations.pages.finance['invoice-table']['master'],
            value: this.item['client_person_data'] ? this.item['client_person_data']['first_name'] + ' ' + this.item['client_person_data']['last_name'] : '-'
          },
          {
            name: this.localStorage.translations.pages.finance['invoice-table']['signing_date'],
            value: this.formatDate(this.item['report_signed_at'])
          },
        ]
      }
    },
    status() {
      switch (this.item['salary_status']) {
        case 'new':
          return {
            color: 'blue',
            text: this.localStorage.translations.pages.finance['invoice-status']['created']
          }
        case 'done':
          return {
            color: 'green',
            text: this.localStorage.translations.pages.finance['invoice-status']['paid']
          }
        default:
          return {
            color: 'yellow',
            text: this.localStorage.translations.pages.finance['invoice-status']['part_paid']
          }
      }
    },
    fileType() {
      if (this.item['report_sign_photo']) {
        if (typeof this.item['report_sign_photo'] === 'string')
          return this.item['report_sign_photo'].split('.')[1] === 'pdf' ? 'application' : 'image'
        return this.item['report_sign_photo'].type.split('/')[0]
      }
      return ''
    }
  },
  data: () => ({
    modal: false,
  }),
  methods: {
    getWeeks(start, end) {
      if (start && end) {
        if (start === end)
          return start
        let result = start
        let i = Number(start)
        while (i < Number(end)) {
          i++
          result = result + ', ' + i
        }
        return result
      }
      return ''
    },
  
    formatDate(date) {
      let result = new Date(date)
      return String(result.getDate()).padStart(2, '0') + '.' +
        String(result.getMonth()).padStart(2, '0') + '.' + result.getFullYear()
    },
    
    formatDate1(date) {
      if (date) {
        let result = date.split('-')
        return result[2] + '.' + result[1] + '.' + result[0]
      }
      return ''
    },
  }
}
</script>

<style scoped>

</style>
